import { IPopularProductForm } from './types';

export const defaultValues: IPopularProductForm = {
  name: '',
  imageUrl: '',
  status: 'Inactive',
};
